import QRInvoiceWrapper from "../pages/admin/salesInvoices/QRInvoiceWrapper";
import Login from "../pages/auth/login/Login";
import LoginWithPhone from "../pages/auth/loginWithPhone/LoginWithPhone";
import PaymentFailed from "../pages/auth/PaymentFailed";
import PaymentPending from "../pages/auth/PaymentPending";
import PaymentSuccess from "../pages/auth/PaymentSuccess";
import ResetPassword from "../pages/auth/resetPassword/ResetPassword";
import SignUp from "../pages/auth/signUp/SignUp";

export const publicRoutes = [
    {
        path: "/login",
        element: <Login/>,
    },
    {
        path: "/payment-success",
        element: <PaymentSuccess />,
    },
    {
        path: "/payment-failed",
        element: <PaymentFailed />,
    },
    {
        path: "/payment-pending",
        element: <PaymentPending />,
    },
    {
        path: "/signup",
        element: <SignUp/>,
    },
    {
        path: "/reset-password",
        element: <ResetPassword/>,
    },
    {
        path: "/login-with-phone",
        element: <LoginWithPhone/>,
    },
    {
        path: "invoice/:id",
        element: <QRInvoiceWrapper />,
    },
]